import styled from "styled-components";

export const FormContainer = styled.div`
  width: 520px;
  margin-bottom: 20px;
`

export const FormWrapper = styled.form`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 16px;

  div {
    font-weight: 400;
  }

  input {
    font-weight: 400;
    font-size: 14px;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: end;
`;